module.exports = __webpack_public_path__ + "static/media/East Tower 1.7ee6f70a.png";